/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Output, Component, EventEmitter, ElementRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { UiSwitcher } from '../../ui-switcher/ui-switcher';
import { Mixin } from '../../../mixins/Mixin';
import { Filterable } from '../../../mixins/Filterable';

@Component({
    selector: 'fe-switcher',
    template: require('./fe-switcher.html'),
    styles: [require('./fe-switcher.less')],
    providers: [
        {provide: NG_VALUE_ACCESSOR, useExisting: FeSwitcher, multi: true}
    ],
})

@Mixin([Filterable])
export class FeSwitcher extends UiSwitcher {

    @Output() clickAction = new EventEmitter();

    constructor(public elementRef: ElementRef) {
        super(elementRef);
    }

    private clicked(event) {
        this.clickAction.emit(event);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/ui-elements/form-elements/fe-switcher/fe-switcher.ts